import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import { BemTiposComponent } from './bem-tipos.component';
import { BemTiposListComponent } from './bem-tipos-list/bem-tipos-list.component';
import { BemTiposFormComponent } from './bem-tipos-form/bem-tipos-form.component';
import {BemTiposRoutingModule} from "./bem-tipos-routing.module";
import {BemTiposApiService} from "./shared/bem-tipos-api.service";
import {BemTiposNavigationService} from "./shared/bem-tipos-navigation.service";
import {BemTiposService} from "./shared/bem-tipos.service";
import {BemSubtiposModule} from "../bem-subtipos/bem-subtipos.module";

@NgModule({
  imports: [
    SharedModule,
    BemSubtiposModule,
    BemTiposRoutingModule
  ],
  providers: [
    BemTiposApiService,
    BemTiposNavigationService,
    BemTiposService
  ],
  declarations: [
    BemTiposComponent, 
    BemTiposListComponent, 
    BemTiposFormComponent
  ],
  exports: [
    BemTiposListComponent
  ]
})
export class BemTiposModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/bem-tipos.module.ts
 **/